/**
 * This method creates a new record in localStorage called external_id
 * that is renewed every 30min if already exist, if not, create a new record.
 */

export const createExternalIdValue = () => {
	try {
		const currentDate = new Date().getTime();
		const value = localStorage.getItem('external_id');

		const randNum = Math.floor(Math.random() * 50000) + 1;
		const unixTime = Math.floor(Date.now() / 1000);
		const external_id = randNum.toString() + unixTime.toString();
		if (!value) {
			const newRecord = { id: external_id, currentDate };
			localStorage.setItem('external_id', JSON.stringify(newRecord));
		} else {
			// if there's a record check the time
			const parsed = JSON.parse(value);
			const registerDate = parsed.fechaActual;
			const differenceTime = currentDate - registerDate;
			const minutes = differenceTime / (1000 * 60); // convert milliseconds to seconds
			if (minutes >= 30) {
				const newRecord = { valor: external_id, fechaActual: currentDate };
				localStorage.setItem('registro', JSON.stringify(newRecord));
			}
		}
	} catch (e) {
		console.log('error generating external_id value');
	}
};
